import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import CiUserAvatar from "@components/base/avatar.vue";
import CiCompanyTile from "@components/companies/CompanyTile.vue";
import { useInternalTracking } from "@composables/internalTracking";
import { useGreeting } from "@composables/onboarding/logged-in-banner.composable";
import CiRouterLink from "@router/router-link.vue";
import { viewportService } from "@services/viewport.service";
import { CurrentUserClass } from "@utils/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'logged-in-banner',
  props: {
    user: null,
    partner: null
  },
  emits: ["tracking-click"],
  setup(__props: any, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { user: CurrentUserClass; partner?: Companies.Tile };



const { propagateTrackClick } = useInternalTracking(emit, "Header");

const greetingPath = useGreeting();
const avatarSize = computed(() => (viewportService.check(viewportService.handheldSizes) ? "md" : "xl"));

return { __sfc: true,props, emit, propagateTrackClick, greetingPath, avatarSize, CiUserAvatar, CiCompanyTile, CiRouterLink, viewportService }
}

})